import { ANALYTICS_EVENT } from "~/configs/analytics";
import {
	$productDetail,
	$selectedProductDetail,
	toggleModal,
} from "~/store/cart";
import CloseIcon from "@/assets/media/icons/close-2.svg";
var ctaTemplate = require("@/modules/components/cta.handlebars");
import { appendCommonStyling } from "~/helpers";
class LoraCTA {
	constructor(
		parentElement,
		data,
		wrapLayout = ".lora-short__overlay__mid-left",
		ctaOverlay = ".lora-cta__overlay",
		ctaItemLayout = ".lora-cta__overlay__product.link-btn",
		multipleLayout = ".lora-cta__overlay.multiple"
	) {
		this.closeIcon = CloseIcon;
		this._parentElement = parentElement;
		this._data = data;
		this._isGrabbing = false;
		this._wrapLayout = wrapLayout;
		this._ctaOverlay = ctaOverlay;
		this._ctaItemLayout = ctaItemLayout;
		this._multipleLayout = multipleLayout;
		this.isManualCart = this._data.hasOwnProperty("isManualCart")
			? this._data.isManualCart
			: false;
		this._isLoading = this._data.hasOwnProperty("isLoading")
			? this._data.isLoading
			: false;
		this.initialCtaLayout();
		if (!this.isManualCart || (this.isManualCart && !this._isLoading)) {
			setTimeout(() => {
				this.renderSelectedProductDetail();
			}, 300);
		}
		this._clickedCallback = null;
	}

	set clickedCallback(value) {
		this._clickedCallback = value;
	}

	get clickedCallback() {
		return this._clickedCallback;
	}

	set isLoading(isLoading) {
		this._isLoading = isLoading;
	}

	get isLoading() {
		return this._isLoading;
	}

	async initialCtaLayout() {
		const wrapLayout = this._parentElement.querySelector(this._wrapLayout);
		const template = document.createElement("template");
		const isMultiple = this._data.products
			? this._data.products.length > 1
			: false;
		var context = {
			bgColor: this._data.backgroundColor,
			textColor: this._data.textColor,
			items: this._data.products,
			urlName: this._data.urlName,
			isMultiple: isMultiple,
			closeIcon: this.closeIcon,
			isNotFullscreen: !this._data.isFullscreen,
			isLoading: this._isLoading,
		};
		wrapLayout.innerHTML = ""; // Clear existing content
		template.innerHTML = `${ctaTemplate(context)}`;
		await wrapLayout.appendChild(template.content.cloneNode(true));
		appendCommonStyling(wrapLayout);
		this.ctaEvents();
	}

	renderSelectedProductDetail() {
		const productDetailId = $selectedProductDetail.get();
		const videoTracking = this._data?.videoTracking;

		if (productDetailId) {
			const [videoId, productSku] = productDetailId.split("_");
			const productDetail = this._data.products.find(
				(product) => product.productSku === productSku
			);
			if (productDetail) {
				$productDetail.set({ ...productDetail });
				toggleModal(videoId, { openProductDetail: true, videoTracking });
			}
			// $selectedProductDetail.set("");
		}
	}

	hasQueryParameters(url) {
		const urlObj = new URL(url);
		return urlObj.search !== "";
	}

	openProductDetailHandle(item, index) {
		let { url, product } = this.getProductInfo(item, index);

		this._parentElement.dispatchEvent(
			new CustomEvent("cta-clicked", {
				detail: {
					url: url,
					index,
					product,
					productDetailId: `${this._data.videoId}_${product.productSku}`,
				},
				composed: true,
				bubbles: true,
			})
		);

		if (!url.match(/^https?:\/\//i)) {
			url = "//" + url;
			window.open(url, "_blank");
		} else {
			if (typeof this._clickedCallback === "function") {
				this._clickedCallback({
					productDetailId: `${this._data.videoId}_${product.productSku}`,
					url,
				});
			} else {
				window.open(url, "_blank");
			}
		}
	}

	getProductInfo(item, index) {
		let url = item.dataset.url;
		// let url = `http://localhost:3000/products/3001`;
		if (this.hasQueryParameters(url)) {
			url = `${url}&vid=${this._data.videoId}&orgid=${this._data.organizationId}`;
		} else {
			url = `${url}?vid=${this._data.videoId}&orgid=${this._data.organizationId}`;
		}
		if (this._data.playlistId) {
			url += `&pid=${this._data.playlistId}`;
		}
		const product = this._data.products[index];
		return { url, product };
	}

	ctaEvents() {
		// Click CTA action
		const modalProduct = this._parentElement.querySelector(".lora-cta__modal");
		const viewMoreButton = modalProduct.querySelector(
			".lora-cta__modal__actions--view-btn__text"
		);

		let ctaOverlays = this._parentElement.querySelectorAll(this._ctaOverlay);
		ctaOverlays.forEach((ctaOverlay) => {
			ctaOverlay.addEventListener("touchstart", (event) => {
				event.stopPropagation();
			});
			ctaOverlay.addEventListener("touchend", (event) => {
				event.stopPropagation();
			});
		});
		let ctaLinks = this._parentElement.querySelectorAll(this._ctaItemLayout);
		ctaLinks.forEach((cta, index) => {
			cta.addEventListener("click", (event) => {
				event.stopPropagation();
				if (this._isGrabbing) {
					return;
				}
				const { url, product } = this.getProductInfo(cta, index);

				//Open cart modal if useCartIntegration is turned on
				if (this._data.useCartIntegration && product.isSynced === true) {
					if (
						!this._data.isFullscreen &&
						typeof this._clickedCallback === "function"
					) {
						this._clickedCallback({
							productDetailId: `${this._data.videoId}_${product.productSku}`,
							url,
							product,
							index,
						});
					} else {
						const videoTracking = this._data?.videoTracking || {};
						$productDetail.set({ ...product });
						toggleModal(this._data.videoId, {
							openProductDetail: true,
							videoTracking,
						});
					}
					return;
				}

				if (product.description) {
					// Show Product Desciription
					// Get modal elements
					const productNameElement = modalProduct.querySelector(
						".lora-cta__modal__body__title"
					);
					const productDescriptionElement = modalProduct.querySelector(
						".lora-cta__modal__body__descriptionp--content"
					);
					const productImageElement = modalProduct.querySelector(
						".lora-cta__modal__img-feature--img"
					);

					// Update modal content with demoProduct data
					productNameElement.textContent = product.name;
					productDescriptionElement.textContent = product.description;
					productImageElement.src = product.image;
					// Set data-url and data-index attributes for the button
					viewMoreButton.textContent = this._data.urlName;
					viewMoreButton.setAttribute("data-url", product.productLink);
					viewMoreButton.setAttribute("data-index", index);
					modalProduct.classList.add("show");
				} else {
					this.openProductDetailHandle(cta, index);
				}
			});
		});

		const overlaySlider = this._parentElement.querySelector(
			this._multipleLayout
		);
		let isDown = false;
		let startX;
		let scrollLeft;

		if (overlaySlider) {
			overlaySlider.addEventListener("mousedown", (e) => {
				isDown = true;
				overlaySlider.classList.add("grabbing");
				startX = e.pageX - overlaySlider.offsetLeft;
				scrollLeft = overlaySlider.scrollLeft;
			});
			overlaySlider.addEventListener("mouseleave", () => {
				isDown = false;
				overlaySlider.classList.remove("grabbing");
			});
			overlaySlider.addEventListener("mouseup", () => {
				isDown = false;
				overlaySlider.classList.remove("grabbing");
				setTimeout(() => {
					this._isGrabbing = false;
				}, 500);
			});
			overlaySlider.addEventListener("mousemove", (e) => {
				if (!isDown) return;
				e.preventDefault();
				this._isGrabbing = true;
				const x = e.pageX - overlaySlider.offsetLeft;
				const walk = (x - startX) * 2; //scroll-fast
				overlaySlider.scrollLeft = scrollLeft - walk;
			});
		}

		const closeBtn = this._parentElement.querySelector(
			".lora-cta__modal__header--close-btn"
		);
		if (closeBtn) {
			closeBtn.addEventListener("click", (e) => {
				e.stopPropagation();
				modalProduct.classList.remove("show");
			});
		}

		if (viewMoreButton) {
			viewMoreButton.addEventListener("click", (e) => {
				e.stopPropagation();
				// Redirect to product link
				const index = parseInt(viewMoreButton.getAttribute("data-index"), 0);
				this.openProductDetailHandle(viewMoreButton, index);
			});
		}
	}
}

export default LoraCTA;
